import ModalSheet from 'components/common/ModalSheet';
import {useTranslation} from 'react-i18next';
import {useMutateFeedback} from 'hooks/useMutateFeedback';
import {createGetRequiredOrOptionalFieldLabel} from 'utils/getRequiredOrOptionalFieldLabel';
import {setFeedbackModalShown} from './utils';
import {redirectToTrustpilot} from './redirectToTrustpilot';
import RateForm, {FormTypes} from 'components/RateForm';
import styles from './styles.module.css';

const GOOD_RATING = 4;

type Props = {
  reservationId: string;
  isOpenModalSheet: boolean;
  onClose: () => void;
};
export const FeedbackModal = ({isOpenModalSheet, reservationId, onClose}: Props) => {
  const {createFeedbackMutation} = useMutateFeedback();
  const {t} = useTranslation();

  const onCloseModal = () => {
    setFeedbackModalShown();
    onClose();
  };

  const onSubmit = (data: FormTypes) => {
    createFeedbackMutation({
      reservation: reservationId,
      rating: data.rating,
      comment: data.comment,
    });
    setFeedbackModalShown();
    onClose();
    if (data.rating >= GOOD_RATING) {
      redirectToTrustpilot();
    }
  };

  return (
    <ModalSheet
      title={
        <div className={styles.FeedbackModal__titleWrapper}>
          <div className={styles.FeedbackModal__title}>{t('feedback_modal.title')}</div>
          <div className={styles.FeedbackModal__subtitle}>
            {t('feedback_modal.subtitle')}
          </div>
        </div>
      }
      isOpenModalSheet={isOpenModalSheet}
      handleCloseModal={() => onCloseModal()}
      withCloseButton
      className={styles.FeedbackModal}
    >
      <RateForm
        onSubmit={onSubmit}
        showRatingStatus
        rateLabel={t('feedback_modal.rating_label')}
        commentsLabel={createGetRequiredOrOptionalFieldLabel(t)(
          t('feedback_modal.additional_comments'),
          false,
        )}
        submitLabel={t('feedback_modal.submit_feedback')}
        commentsPlaceholder={' '}
        className={styles.FeedbackModal__rateForm}
      />
    </ModalSheet>
  );
};
